<template>
  <div class="quiz-nav-buttons">
    <custom-button
      v-if="showP"
      :caption="previous"
      @clicked="$emit('back')"
      class="back"
      :uppercase="true"
      size="big"
    />
    <custom-button
      v-if="showN"
      :caption="next"
      @clicked="$emit('next')"
      class="next"
      :uppercase="true"
      size="big"
    />
  </div>
</template>
<script>
import Button from "../components/Button.vue";

export default {
  name: "QuestionsNav",
  components: {
    CustomButton: Button
  },
  props: {
    showN: {
      type: Boolean,
      default: true
    },
    showP: {
      type: Boolean,
      default: true
    },
    previous: {
      type: String,
      default: "Back"
    },
    next: {
      type: String,
      default: "Next"
    }
  }
};
</script>
<style lang="scss" scoped>
.quiz-nav-buttons {
  margin: 160px auto 0;
  width: 50%;
  justify-content: space-around;
  display: flex;

  .custom-button {
    padding: 7px 75px;
    border: 1px solid $color-gray;
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }

    &.back {
      background: none;
      box-shadow: none;
      color: $color-gray;
    }

    &.next {
      background-color: $color-primary;
      color: $color-white;
    }
  }
}

@media (max-width: 890px) {
  .quiz-nav-buttons {
    width: 85%;
  }
}

@media (max-width: 600px) {
  .quiz-nav-buttons {
    width: 75%;
    margin-top: 75px;
    flex-direction: column;
    .custom-button {
      display: block;
      text-align: center;
      margin-bottom: 28px;

      margin-right: 20px;
      &:first-child {
        margin-right: 0;
      }

      &.back {
        order: 1;
      }
    }
  }
}

@media (max-width: 450px) {
  .quiz-nav-buttons {
    .custom-button {
      padding: 7px 25px;
    }
  }
}
</style>